import { render, staticRenderFns } from "./homeProduct.vue?vue&type=template&id=1c2d2ee2&scoped=true&"
import script from "./homeProduct.vue?vue&type=script&lang=ts&"
export * from "./homeProduct.vue?vue&type=script&lang=ts&"
import style0 from "./homeProduct.vue?vue&type=style&index=0&id=1c2d2ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d2ee2",
  null
  
)

export default component.exports